import { useRef } from "react";

import { Image } from "@/components/Image/Image";
import { useDraggable } from "@/hooks/useDraggable";
import { WHATSAPP_URL } from "@/utils/constants";

interface WhatsAppButtonProps {
  bottomPosition?: string;
  onClick?: () => void;
}

export function WhatsAppButton({
  bottomPosition,
  onClick,
}: WhatsAppButtonProps) {
  const constraintsRef = useRef(window.document.body);
  const { ref, onPointerDown, onClickCapture } =
    useDraggable<HTMLAnchorElement>({
      dragConstraints: constraintsRef,
      dragScale: 1.2,
    });

  return (
    <a
      ref={ref}
      onClick={onClick}
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      // https://mui.com/material-ui/customization/z-index/
      // The z-index is set to be below the MUI drawer which has a z-index of 1200
      className="fixed right-4 z-1100 cursor-grab touch-none rounded-full bg-surface-accent-stronger p-3 shadow shadow-black/40 select-none"
      onPointerDown={onPointerDown}
      onClickCapture={onClickCapture}
      style={{
        bottom:
          bottomPosition ??
          "calc(var(--main-bottom-padding) + var(--footer-height, 0))",
      }}
    >
      <Image
        src="/whatsAppLogo.svg"
        className="pointer-events-none"
        width={24}
        height={24}
        alt="whatsapp-logo"
      />
    </a>
  );
}
